export const BREAKPOINTS = { LARGE: 1120, MEDIUM: 768, SMALL: 576 };
export function prefersReducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
export function preloadImages(urls) { urls.forEach(url => { const img = new Image(); img.src = url; }); }
export function generateModifierClasses(componentClass, modifiers) { if (!modifiers) {
    return componentClass;
} return [].concat(modifiers).map(modifier => `${componentClass}--${modifier}`).concat([componentClass]).join(' '); }
export function buttonClasses(classes, modifiers, type) { let buttonClasses = classes || []; modifiers = modifiers || []; if (type == 'submit') {
    modifiers = [].concat(modifiers).concat('primary');
} buttonClasses = buttonClasses.concat(generateModifierClasses('button', modifiers)); return buttonClasses.join(' '); } // Escapes a value for safe interpolation into an innerHTML/insertAdjacentHTML string
// (e.g. building up markup with a user-controlled value like a name). Prefer avoiding
// innerHTML entirely where possible, but this is required for the few legacy helpers
// (e.g. updatePageTitle, setHeaderAction) that still build HTML strings directly.
export function escapeHtml(value) { return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); } // Server error (5xx) responses aren't guaranteed to be JSON - e.g. an unhandled
// exception in production renders Rails' static public/500.html page - so parsing
// needs to tolerate a non-JSON body instead of throwing.
function safeParseJson(response) { try {
    return JSON.parse(response);
}
catch {
    return undefined;
} }
export function fetch(method, railsRoute, contentType = null, accept = null, data = null, noAuth = false) {
    return new Promise(function (resolve, reject) {
        const xhr = new XMLHttpRequest();
        xhr.open(method, railsRoute);
        window.ajaxCount = window.ajaxCount == -1 ? 1 : (window.ajaxCount || 0) + 1;
        if (['POST', 'PATCH', 'PUT', 'DELETE'].indexOf(method) >= 0 && !noAuth) {
            const tokenElement = document.querySelector('meta[name="csrf-token"]');
            const auth = tokenElement && tokenElement.getAttribute('content');
            xhr.setRequestHeader('X-CSRF-Token', auth || '');
        }
        if (contentType) {
            xhr.setRequestHeader('Content-Type', contentType);
        }
        if (accept) {
            xhr.setRequestHeader('Accept', contentType || accept);
        }
        xhr.onload = function ({ target }) {
            // JSON. This is just to log those responses when that happens to help
            // with debugging:
            if (!includes(['{', '['], target?.response[0]) && window.rg4js) {
                window.rg4js('recordBreadcrumb', 'Unparseable success JSON', { response: target.response });
            }
            window.ajaxCount = (window.ajaxCount || 0) - 1;
            console.log(`Fetched ${railsRoute} - ${window.ajaxCount || 'None'} remain.`);
            if (target.status >= 500) {
                if (window.rg4js) {
                    window.rg4js('send', { error: new Error(`${method} ${railsRoute} failed with ${target.status}`), customData: { method, path: railsRoute, status: target.status } });
                }
                return reject([target.statusText, safeParseJson(target.response)]);
            } // We're logged out and Rails is returning us the login screen HTML.
            if (target && target.response.indexOf('You need to sign in or sign up') !== -1) {
                window.location.href = '/users/sign_in?session_expired=t';
            }
            if (target.status !== 200) {
                return reject([target.statusText, JSON.parse(target.response)]);
            }
            resolve(JSON.parse(target.response));
        };
        xhr.onerror = function (e) { window.ajaxCount = (window.ajaxCount || 0) - 1; console.log(`Failed to fetch ${railsRoute} - ${window.ajaxCount || 'None'} remain.`); if (window.rg4js) {
            window.rg4js('send', e);
        } return reject(e); };
        xhr.send(data && JSON.stringify(data));
    });
}
export function fullPath(path, queryObject) { const queryString = Object.keys(queryObject).map(key => key + '=' + queryObject[key]).join('&'); return queryString ? `${path}?${queryString}` : path; }
export function redirectTo(path) { window.location.href = path; } // The pathname of document.referrer, if it's same-origin - the client-side
// equivalent of the old server-side request.referer-based redirect fallback,
// useful for pages reachable both from within the SPA router (which should
// prefer router location state instead) and from full page loads originating
// on non-SPA pages (where there's no router state to fall back on).
export function referrerPathname() { if (!document.referrer)
    return null; try {
    const referrerUrl = new URL(document.referrer);
    if (referrerUrl.origin !== window.location.origin)
        return null;
    return referrerUrl.pathname;
}
catch {
    return null;
} }
export function propagateValue(name, value) { const { handlePropagation, onChange } = this.props; if (handlePropagation) {
    const method = methodFromString(handlePropagation);
    if (method)
        method(name, value);
} if (onChange) {
    onChange({ [name]: value });
} }
export function methodCallFromString(originalOnClick) { let onClick = originalOnClick; if (typeof originalOnClick === 'string') {
    onClick = function () { try {
        const callableFunction = new Function('event', originalOnClick);
        callableFunction.call(this);
    }
    catch (error) {
        console.error('Error executing the function:', error);
    } };
} return onClick; }
export function methodFromString(string) { if ('function' === typeof string) {
    return string;
} const keys = string.replace('window.', '').split('.'); let object = window; for (let i = 0; i < keys.length; i++) {
    object = object[keys[i]];
} if ('function' === typeof object) {
    return object;
} return false; } // If you are requesting the same path as your current path, you may need to add `.json`
// to the path so that browsers don't cache the request when navigating back and forward
export function setStateFromPath(method, path, emptyState = {}) { return fetch(method, path, 'application/json', 'application/json').then(data => this.setState(data || emptyState)).catch(e => { if (e) {
    console.error('Fetch failed: ' + e);
} }); }
export function setStateValueFromPath(method, path, value) { fetch(method, path, 'application/json', 'application/json').then(data => this.setState({ [value]: data })).catch(e => { if (e) {
    console.error('Fetch failed: ' + e);
} }); }
export function isIterable(obj) { if (!obj) {
    console.error('Expected an iterable, got nothing.');
    return false;
} if (typeof obj[Symbol.iterator] === 'function') {
    return true;
}
else {
    console.error(`Expected an iterable, got: ${obj}.`);
    return false;
} }
export function helperId() { const { name, id, helperId } = this.props; return helperId || `helper-${name || id}`; }
export function inputName() { const { name, resourceName } = this.props; return `${resourceName}[${name}]`; } // Strips brackets from a resource name (e.g. "user[address]") so it's safe to use in an HTML id attribute
export function sanitizeResourceName(resourceName) { return (resourceName || '').replace(/\[/g, '_').replace(/\]/g, ''); }
export function inputId(includeValue = true) { const { name, value, resourceName } = this.props; let niceValue = value; if (typeof niceValue == 'string')
    niceValue = niceValue.toLowerCase(); const prefix = sanitizeResourceName(resourceName); return includeValue ? `${prefix}_${name}_${niceValue}` : `${prefix}_${name}`; } // TO-DO: This is a fair amount of DOM manipulation for a utility function.
// Consider moving this logic into a dedicated component or hook to better separate concerns.
export function highlightFirstError() {
    setTimeout(function () {
        const errorItem = document.querySelector('.form-group--error');
        if (!errorItem)
            return false;
        errorItem.closest('.form-group--error')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        errorItem.classList.remove('shake');
        setTimeout(function () {
            // picker's floating dropdown when the highlighted field is a date input.
            errorItem.classList.add('animated', 'animated--snail', 'shake', 'show-overflow'); // Remove the classes once the shake ends - leaving them keeps `transform`
            // non-`none`, which turns this field into a containing block/stacking
            // context and hijacks any floating dropdown/overlay inside it.
            errorItem.addEventListener('animationend', () => { errorItem.classList.remove('animated', 'animated--snail', 'shake', 'show-overflow'); }, { once: true });
        }, 100);
    }, 100);
}
export function mapSrc(center, width, height, zoom = null) { const { google_api_key } = window; let src = `https://maps.googleapis.com/maps/api/staticmap?key=${google_api_key}&center=${center}&size=${width}x${height}&scale=2`; if (zoom)
    src = `${src}&zoom=${zoom}`; return src; } // Lazily injects the Google Maps JS SDK (window.google.maps.*) only when a
// component that actually needs it (e.g. Map.tsx) mounts, rather than on
// every page via the layout. Caches the in-flight/resolved promise so
// multiple mounts (or StrictMode's double-invoke) don't inject the script
// more than once.
let googleMapsScriptPromise = null;
export function loadGoogleMapsScript() { if (window.google?.maps) {
    return Promise.resolve();
} if (!googleMapsScriptPromise) {
    googleMapsScriptPromise = new Promise((resolve, reject) => { const { google_api_key } = window; const script = document.createElement('script'); script.src = `https://maps.googleapis.com/maps/api/js?key=${google_api_key}&libraries=places`; script.async = true; script.onload = () => resolve(); script.onerror = () => { googleMapsScriptPromise = null; reject(new Error('Failed to load the Google Maps script')); }; document.head.appendChild(script); });
} return googleMapsScriptPromise; }
export function hasValues(obj) { if (!obj) {
    return false;
} const values = Object.keys(obj).map(key => obj[key]); return values.some(value => !!value); }
export function existsByProperty(array, value, property) { return array.find(currentItem => currentItem[property] == value); }
export function mergeOrAddByProperty(array, item, property) { const existingItem = existsByProperty(array, item[property], property); if (!existingItem) {
    return array.concat(item);
} array.splice(array.indexOf(existingItem), 1, item); return array; }
export function getOrdinalIndicator(date) { if (date > 3 && date < 21)
    return 'th'; switch (date % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
} }
export function omit(obj, omittedKeys) { if (!obj) {
    return {};
} const result = {}; const keys = Object.keys(obj); keys.forEach(key => { if (omittedKeys.indexOf(key) === -1) {
    result[key] = obj[key];
} }); return result; }
export function capitalize(string) { return `${string[0].toUpperCase()}${string.slice(1)}`; }
export function pick(obj, pickedKeys) { if (!obj) {
    return {};
} if (!pickedKeys || !pickedKeys.length) {
    return { ...obj };
} const result = {}; pickedKeys.forEach(key => { if (obj[key] !== undefined) {
    result[key] = obj[key];
} }); return result; }
export function snakeCase(str) { return str && str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)?.map(x => x.toLowerCase()).join('_'); }
export function flatten(array) { let result = []; for (let i = 0; i < array.length; i++) {
    result = result.concat(array[i]);
} return result; }
export function groupBy(items, key) { const result = {}; items.forEach(item => { if (result[item[key]]) {
    result[item[key]].push(item);
}
else {
    result[item[key]] = [item];
} }); return result; }
export function uuidv4() { const str = () => ('00000000000000000' + (Math.random() * 0xffffffffffffffff).toString(16)).slice(-16); const a = str(); const b = str(); return a.slice(0, 8) + '-' + a.slice(8, 12) + '-4' + a.slice(13) + '-a' + b.slice(1, 4) + '-' + b.slice(4); }
export function isUuidv4(value) { return typeof value === 'string' && new RegExp('^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$', 'i').test(value); }
export const findBy = (items, property, value) => { return items.find(e => e[property] == value); };
export const findIndexBy = (items, property, value) => { return items.findIndex(e => e[property] == value); };
export const removeIndex = (items, index) => { const result = [].concat(items); result.splice(index, 1); return result; };
export const updateIndex = (items, index, newEntry) => { const result = [].concat(items); result[index] = newEntry; return result; };
export const deDupe = items => { return [...new Set(items)]; };
export const pluck = (items, key) => { return items.map(item => item[key]); };
export const includes = (items, item) => { return items.indexOf(item) !== -1; };
export const values = obj => { if (!obj) {
    return [];
} return Object.keys(obj).map(e => obj[e]); };
export const toggleInclusion = (items, item) => { const index = items.indexOf(item); if (index === -1) {
    return [item].concat(items);
} return removeIndex(items, index); };
export const goToEndOfInput = input => {
    if (input.createTextRange) {
        const fieldRange = input.createTextRange();
        fieldRange.collapse(false);
        fieldRange.select();
    }
    else {
        const length = input.value.length; // Waits for the cursor to be placed.
        setTimeout(function () { input.setSelectionRange(length, length); }, 0);
    }
};
export function isPlainClick(e) { return !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey; }
